import Vue from 'vue'
import Vuex from 'vuex'
import Menu from '@/menu/index.js'
import {setPermissions,getPermissions,getUserInfo,setUserInfo,setToken} from '@/utils/dataStorage.js'
import FilterMenu from '@/utils/filterMenuByPermission.js'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    canBack:false,
    siteTitle:'',
    menu:{},
  },
  mutations: {
    initMenu(state){//初始化菜单和返回总后台按钮用，如刷新页面了
      let userInfo = getUserInfo();
      state.menu = FilterMenu(Menu,userInfo.managerPermissionCodeSet);
      state.canBack = userInfo.back;
      state.siteTitle = userInfo.orgName;
    },
    setPermissionsMenuAndUpdateBtn(state,r){//权限变化时使用此方法设置，登陆或者进入子机构使用
      setUserInfo(r);
      setToken(r.token);
      setPermissions(r.managerPermissionCodeSet);
      state.menu = FilterMenu(Menu,r.managerPermissionCodeSet);
      state.canBack = r.back;
      state.siteTitle = r.orgName;
    }
  }
})


